import { RouteType } from "../../types/RouteType";

const BOMRoute: RouteType = {
  name: "BOM Workflow",
  path: "/bom/workflow",
  layout: "/app",
  requiresAuth: true,
  viewportCard: {
    header: {
      component: () => import("./BOMWorkflowHeader"),
      title: "Bill of Materials",
      enableRefreshButton: true,
      enableBackButton: false,
    },
    body: {
      component: () => import("./BOMWorkflow"),
      grayBackground: true,
    },
  },
  requiresPermission: false,
  beforeEnter: async ({ rootStore }) => {
    // Load products if not already loaded
    if ((rootStore as any).productsStore.entities.length === 0) {
      await (rootStore as any).productsStore.find({
        query: {
          active: true,
          $limit: 500,
        },
      });
    }

    // Load BOM items if not already loaded
    if ((rootStore as any).bomItemsStore?.entities.length === 0) {
      await (rootStore as any).bomItemsStore.find({
        query: {
          active: true,
          $limit: 1000,
        },
      });
    }

    // Optionally load existing BOMs
    if ((rootStore as any).billOfMaterialsStore) {
      await (rootStore as any).billOfMaterialsStore.find({
        query: {
          active: true,
          $limit: 100,
        },
      });
    }

    return true;
  },
  onParamsChange: async ({ rootStore, params, queryParams }) => {
    // Handle productId if passed as query param
    if (queryParams?.productId && (rootStore as any).bomViewStore) {
      const productId = Number(queryParams.productId);
      if (!isNaN(productId)) {
        (rootStore as any).bomViewStore.setSelectedProduct(productId);
      }
    }
  },
};

export default BOMRoute;
